import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import { Broker, BrokerSubscriber } from '@c4/core';

const STORE_NAME: string = 'SYSMAN';
const UPDATE_LOG: string = STORE_NAME + ':UPDATE_OUTPUT_LOG';
const CLEAR_LOG: string = STORE_NAME + ':CLEAR_OUTPUT_LOG';

export const outputLogReducer = (state: any, {type, payload}) => {
  switch (type) {
    case UPDATE_LOG: // append log entry to existing output

      if (state.outputlog)
        return Object.assign({}, {"outputlog" : state.outputlog + payload.outputlog});
      else
        return Object.assign({}, {"outputlog" : payload.outputlog});

    case CLEAR_LOG:
      return Object.assign({}, {"outputlog":""});

    default:
      return state;
  }
};

@Injectable()
export class OutputLogService {

  outputLog : Observable<any>;
  timer: any;

  constructor(private store: Store<any>, private broker: Broker) {
    this.outputLog = this.store.select('outputlog');
  }

  // use ip = "" for current broker
  startOutputLog(ip : string) {
    console.log('OutputLogService: startOutputLog()', ip);
    this.clearOutputLog();

    this.broker.call({
            method: 'GET',
            path: '/api/v1/sysman/sysinfo' + ((ip!=="") ? "?ip=" + ip : "")
        }).then(
        (result : any) => {
              this.store.dispatch({ type: UPDATE_LOG, payload: { outputlog: result } });
        },
        (err : any) => {
            console.log('OutputLogService.startOutputLog() error', err);             
        }
      );
  }

  stopOutputLog() {
    this.clearOutputLog();
  }

  clearOutputLog() {
    this.store.dispatch({ type: CLEAR_LOG });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/output-log.service.ts